export default "__VITE_ASSET__CqpaiaQu__"